module.exports = __webpack_public_path__ + "static/media/promotionResumptionPackageUnder50.bb12ff68.webp";